module.exports = __webpack_public_path__ + "img/intro-to-illustrator-2022.5f66c060.svg";